import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { BentoBoxSection } from "./BentoBoxSection/BentoBoxSection";
import { BentoBoxSectionV2 } from "./BentoBoxSectionV2/BentoBoxSectionV2";
import { HeadingSection } from "./HeadingSection/HeadingSection";
import { FooterSection } from "./FooterSection/FooterSection";
import styles from "./BentoBoxHomepage.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BentoBoxHomepage = function BentoBoxHomepage(_ref) {
  var headingSection = _ref.headingSection,
    footerSection = _ref.footerSection,
    bentoBoxSection = _ref.bentoBoxSection,
    bentoBoxSectionV2 = _ref.bentoBoxSectionV2,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? 'v3' : _ref$version,
    _ref$css = _ref.css,
    css = _ref$css === void 0 ? '' : _ref$css,
    _ref$template = _ref.template,
    template = _ref$template === void 0 ? 'default' : _ref$template;
  var hasCss = css && css.length > 0;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.bentoBoxHomepageContainer, {
      [styles.defaultTemplate]: template === 'default'
    }),
    children: [hasCss && /*#__PURE__*/_jsx("style", {
      children: css
    }), /*#__PURE__*/_jsx(HeadingSection, _objectSpread({}, headingSection)), bentoBoxSection && /*#__PURE__*/_jsx(BentoBoxSection, _objectSpread(_objectSpread({}, bentoBoxSection), {}, {
      version: version,
      template: template
    })), bentoBoxSectionV2 && /*#__PURE__*/_jsx(BentoBoxSectionV2, _objectSpread({}, bentoBoxSectionV2)), /*#__PURE__*/_jsx(FooterSection, _objectSpread({}, footerSection))]
  });
};